var nhkp = nhkp || {};

; (function ($) {
  "use strict";

  nhkp.wave = {
    init: function(){
      var size01 = window.innerWidth < 640 ? 35 : 70,
          size02 = window.innerWidth < 640 ? 25 : 50;

      $('#mvWave01').wavify({height:size01,bones:2,amplitude:size01,color:'#fff',speed:.15});
      $('#mvWave02').wavify({height:size01,bones:2,amplitude:size01,color:'#fff',speed:.15});
      $('#mvWave03').wavify({height:size01,bones:2,amplitude:size01,color:'#fff',speed:.15});
      $('#mvWave04').wavify({height:size02,bones:3,amplitude:size02,color:'#fff',speed:.25});
      $('#mvWave05').wavify({height:size02,bones:3,amplitude:size02,color:'#fff',speed:.25});
      $('#mvWave06').wavify({height:size02,bones:3,amplitude:size02,color:'#fff',speed:.25});

      $('#publicationWave01').wavify({height:size02,bones:3,amplitude:size02,color:'#98a3cc',speed:.15});
      $('#publicationWave02').wavify({height:size02,bones:3,amplitude:size02,color:'#5367aa',speed:.15});
      $('#publicationWave03').wavify({height:size02,bones:3,amplitude:size02,color:'#1b368e',speed:.15});
      $('#publicationWave04').wavify({height:size02,bones:3,amplitude:size02,color:'#baf8fd',speed:.25});
      $('#publicationWave05').wavify({height:size02,bones:3,amplitude:size02,color:'#8bf3fb',speed:.25});
      $('#publicationWave06').wavify({height:size02,bones:3,amplitude:size02,color:'#61e7f5',speed:.25});

      $('#radioWave01').wavify({height:size02,bones:3,amplitude:size02,color:'#c898cb',speed:.15});
      $('#radioWave02').wavify({height:size02,bones:3,amplitude:size02,color:'#a454a8',speed:.15});
      $('#radioWave03').wavify({height:size02,bones:3,amplitude:size02,color:'#861c8b',speed:.15});
      $('#radioWave04').wavify({height:size02,bones:3,amplitude:size02,color:'#fdbae0',speed:.25});
      $('#radioWave05').wavify({height:size02,bones:3,amplitude:size02,color:'#f889ca',speed:.25});
      $('#radioWave06').wavify({height:size02,bones:3,amplitude:size02,color:'#f260b7',speed:.25});

      $('#recordWave01').wavify({height:size02,bones:3,amplitude:size02,color:'#99cbc0',speed:.15});
      $('#recordWave02').wavify({height:size02,bones:3,amplitude:size02,color:'#58aa95',speed:.15});
      $('#recordWave03').wavify({height:size02,bones:3,amplitude:size02,color:'#218f72',speed:.15});
      $('#recordWave04').wavify({height:size02,bones:3,amplitude:size02,color:'#e6fdba',speed:.25});
      $('#recordWave05').wavify({height:size02,bones:3,amplitude:size02,color:'#d3fb8b',speed:.25});
      $('#recordWave06').wavify({height:size02,bones:3,amplitude:size02,color:'#c2f765',speed:.25});

      $('#televisionWave01').wavify({height:size02,bones:3,amplitude:size02,color:'#cc9898',speed:.15});
      $('#televisionWave02').wavify({height:size02,bones:3,amplitude:size02,color:'#aa5353',speed:.15});
      $('#televisionWave03').wavify({height:size02,bones:3,amplitude:size02,color:'#8f1c1c',speed:.15});
      $('#televisionWave04').wavify({height:size02,bones:3,amplitude:size02,color:'#fdbaba',speed:.25});
      $('#televisionWave05').wavify({height:size02,bones:3,amplitude:size02,color:'#fa8a8a',speed:.25});
      $('#televisionWave06').wavify({height:size02,bones:3,amplitude:size02,color:'#f66262',speed:.25});

      $('#portableWave01').wavify({height:size02,bones:3,amplitude:size02,color:'#b7c9c8',speed:.15});
      $('#portableWave02').wavify({height:size02,bones:3,amplitude:size02,color:'#86a5a4',speed:.15});
      $('#portableWave03').wavify({height:size02,bones:3,amplitude:size02,color:'#5f8886',speed:.15});
      $('#portableWave04').wavify({height:size02,bones:3,amplitude:size02,color:'#e6efef',speed:.25});
      $('#portableWave05').wavify({height:size02,bones:3,amplitude:size02,color:'#d5e4e3',speed:.25});
      $('#portableWave06').wavify({height:size02,bones:3,amplitude:size02,color:'#c6dad9',speed:.25});

      $('#smartphoneWave01').wavify({height:size02,bones:3,amplitude:size02,color:'#ccc498',speed:.15});
      $('#smartphoneWave02').wavify({height:size02,bones:3,amplitude:size02,color:'#aa9d53',speed:.15});
      $('#smartphoneWave03').wavify({height:size02,bones:3,amplitude:size02,color:'#8f7e1c',speed:.15});
      $('#smartphoneWave04').wavify({height:size02,bones:3,amplitude:size02,color:'#fdf3ba',speed:.25});
      $('#smartphoneWave05').wavify({height:size02,bones:3,amplitude:size02,color:'#f8e889',speed:.25});
      $('#smartphoneWave06').wavify({height:size02,bones:3,amplitude:size02,color:'#f6df62',speed:.25});
    }
  };

  nhkp.modal = {
    box: '.modal__box',
    cnt : '.modal__box__inner',
    trigger: '.modal__trigger',
    close: '.modal__box__close__btn',
    init: function () {
      var _self = this;

      $(document).on('click', function (e) {
        if ($(_self.box).is(':visible')) {
          if (typeof $(e.target).closest(_self.cnt)[0] === 'undefined') {
            e.preventDefault();
            $(_self.box).hide();
            $('html').removeClass('is-modal is-rd');
            _self.audio();
            _self.video();
          }
        }
      });

      $(_self.close).on('click', function (e) {
        e.preventDefault();
        $(_self.box).hide();
        $('html').removeClass('is-modal is-rd');
        _self.audio();
        _self.video();
      });

      $(_self.trigger).on('click', function (e) {
        e.stopPropagation();
        var href = $(this).attr('href'), 
            $target = $('#' + href);

        $target.fadeIn();
        $('html').addClass('is-modal');

        if(href == 'radio__desc' || href == 'record__desc'){
          $('html').addClass('is-rd');
        }
        return false;
      });

      document.addEventListener('touchmove', function(e) {
        if($('html').hasClass('is-rd')){
          e.preventDefault();
        }
      }, {passive: false});
    },
    audio : function(){
      var audio = document.getElementById('audioRadio');
      audio.pause();
      audio.currentTime = 0;
    },
    video : function(){
      var video = document.getElementById('recordMovie');
      video.pause();
      video.currentTime = 0;
    }
  };
  
  nhkp.sns = {
    facebook:'#facebook',
    twitter:'#twitter',
    init: function () {
      var _self = this;
      $(_self.facebook).on('click',function(){
        var url = location.href,
            link = 'http://www.facebook.com/share.php?u='+ url;
        
        window.open(link, '', 'width=580,height=400,menubar=no,toolbar=no,scrollbars=yes');
        return false;
      });
      $(_self.twitter).on('click',function(){
        var url = location.href,
            text = $('[name="twitter:description"]').attr('content'),
            link = 'https://twitter.com/share?text='+text+'&url='+ url;

        window.open(link, '', 'width=580,height=400,menubar=no,toolbar=no,scrollbars=yes');
        return false;
      });
    }
  };

  nhkp.observer = {
    init: function () {
      var _self = this,
        target = document.querySelectorAll('.js-object'),
        observer = new IntersectionObserver(function (changes) {
          if (changes[0].isIntersecting) {
            changes[0].target.classList.add('is-intersected');
            observer.unobserve(changes[0].target);
          }
        },
          {
            root: null,
            rootMargin: '130px 40px 40px 40px',
            threshold: [0, 0.1, 0.3, 0.6, 0.9, 1]
          });

      for (var i = 0; i < target.length; i++) {
        observer.observe(target[i]);
      }
    }
  };

  nhkp.unit = {
    init: function(){
      var _self = this;
      document.getElementsByTagName('html')[0].oncontextmenu = function () {
        return false;
      }
    },
    load: function(){
      var hash = (location.hash && location.hash != '#') ? location.hash: null;
      if(hash){
        window.history.pushState(null, null, location.href.replace(hash, '') );
        hash = hash.replace('#anc_', '');
          var target = document.getElementById(hash),
              pos = target.offsetTop;
        setTimeout(function(){
          $.when(
            $('body,html').stop().animate({ scrollTop: pos },1000)
          ).done(function() {
            var diff = target.offsetTop;
            if (diff !== pos) {
              $('body,html').stop().animate({ scrollTop: diff },1000);
            }
          });
        },2000);
      }
    }
  };

  window.addEventListener('DOMContentLoaded', function () {
    nhkp.wave.init();
    nhkp.modal.init();
    nhkp.sns.init();
    nhkp.observer.init();
    nhkp.unit.init();
  });

  window.addEventListener('load', function () {
    nhkp.unit.load();
  });

})(jQuery);